export default "__VITE_ASSET__BVIrDXYO__"